import { useEffect, useState } from 'react';
import { theme } from '~ui-kit/theme';

interface DeviceScreenSize {
  isExtraSmall: boolean;
  isSmall: boolean;
  isMedium: boolean;
  isLarge: boolean;

  // General (xs or sm)
  isMobile: boolean;
  // General (md or lg)
  isDesktop: boolean;

  screenWidth: number;
}

function getDeviceScreenSize(screenWidth: number): DeviceScreenSize {
  const firstBp = parseInt(theme.breakpoints[0], 10);
  const secondBp = parseInt(theme.breakpoints[1], 10);
  const thirdBp = parseInt(theme.breakpoints[2], 10);

  const isExtraSmall = screenWidth < firstBp;
  const isSmall = screenWidth >= firstBp && screenWidth < secondBp;
  const isMedium = screenWidth >= secondBp && screenWidth < thirdBp;
  const isLarge = screenWidth >= thirdBp;

  return {
    isExtraSmall,
    isSmall,
    isMedium,
    isLarge,
    isMobile: isExtraSmall || isSmall,
    isDesktop: isMedium || isLarge,
    screenWidth,
  };
}

// Hook to detect screen size
export const useDeviceScreenSize = (): DeviceScreenSize => {
  const [deviceScreenSize, setDeviceScreenSize] = useState<DeviceScreenSize>(getDeviceScreenSize(window.innerWidth));

  useEffect(() => {
    function handleWindowResize() {
      setDeviceScreenSize(getDeviceScreenSize(window.innerWidth));
    }

    // Subscribe to resize event
    window.addEventListener('resize', handleWindowResize);

    // Unsubscribe to event when unmount
    return () => window.removeEventListener('resize', handleWindowResize);
  }, []);

  return deviceScreenSize;
};
